import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white pb-20 pt-40 md:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-violet-400 hover:text-violet-300 mb-8 transition-colors"
        >
          <ArrowLeft size={20} className="mr-2" />
          Zurück zur Startseite
        </button>

        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold mb-8">
            <span className="text-gradient">Datenschutzerklärung</span>
          </h1>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Datenschutz auf einen Blick</h2>
              <h3 className="text-lg font-semibold text-violet-400 mb-2">Allgemeine Hinweise</h3>
              <p className="leading-relaxed">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
                passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
                persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Allgemeine Hinweise und Pflichtinformationen</h2>
              <h3 className="text-lg font-semibold text-violet-400 mb-2">Datenschutz</h3>
              <p className="leading-relaxed mb-4">
                Der Betreiber dieser Seiten nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Ihre personenbezogenen 
                Daten werden vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser 
                Datenschutzerklärung behandelt.
              </p>
              
              <h3 className="text-lg font-semibold text-violet-400 mb-2">Verantwortliche Stelle</h3>
              <p className="leading-relaxed mb-2">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="space-y-1 mb-4">
                <p>Stefan Hay</p>
                <p>Einzelunternehmer (Freelancer für Digitale Kommunikation)</p>
                <p>Königsallee 24</p>
                <p>44789 Bochum</p>
                <p>Deutschland</p>
                <p>Telefon: +49 176 60969801</p>
                <p>E-Mail: stefan@haylights.de</p>
              </div>
              <p className="leading-relaxed mb-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen 
                über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
              </p>

              <h3 className="text-lg font-semibold text-violet-400 mb-2">Hinweis zur SSL-/TLS-Verschlüsselung</h3>
              <p className="leading-relaxed">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte – etwa über 
                das Kontaktformular – eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, 
                dass die Adresszeile Ihres Browsers von „http://" auf „https://" wechselt und ein Schloss-Symbol in Ihrer 
                Browserzeile angezeigt wird.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Datenerfassung auf dieser Website</h2>
              <h3 className="text-lg font-semibold text-violet-400 mb-2">Kontaktformular</h3>
              <p className="leading-relaxed mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der von Ihnen 
                angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen gespeichert. 
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="leading-relaxed mb-4">
                <strong>Rechtsgrundlage:</strong> Die Verarbeitung der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
                (Vertrag oder vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
              </p>

              <h3 className="text-lg font-semibold text-violet-400 mb-2">Server-Log-Dateien</h3>
              <p className="leading-relaxed mb-4">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, 
                die Ihr Browser automatisch übermittelt. Dies sind:
              </p>
              <ul className="list-disc list-inside space-y-1 mb-4 ml-4">
                <li>Browsertyp und Browserversion</li>
                <li>verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <p className="leading-relaxed mb-4">
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
              </p>
              <p className="leading-relaxed mb-4">
                <strong>Rechtsgrundlage:</strong> Die Erhebung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. 
                Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und Optimierung 
                seiner Website.
              </p>

              <h3 className="text-lg font-semibold text-violet-400 mb-2">Cookies</h3>
              <p className="leading-relaxed">
                Diese Website verwendet keine Cookies, die personenbezogene Daten speichern oder das Nutzerverhalten 
                analysieren. Sollte sich dies zukünftig ändern, wird an dieser Stelle entsprechend informiert und ggf. 
                Ihre Einwilligung eingeholt.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Ihre Rechte</h2>
              <p className="leading-relaxed mb-4">
                Sie haben jederzeit das Recht auf:
              </p>
              <ul className="list-disc list-inside space-y-2 mb-4 ml-4">
                <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
              </ul>

              <h3 className="text-lg font-semibold text-violet-400 mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p className="leading-relaxed mb-4">
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine 
                bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der Verarbeitung bis zum Widerruf 
                bleibt davon unberührt.
              </p>

              <h3 className="text-lg font-semibold text-violet-400 mb-2">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
              <p className="leading-relaxed mb-4">
                Im Falle datenschutzrechtlicher Verstöße steht Ihnen ein Beschwerderecht bei einer Aufsichtsbehörde zu. 
                Zuständig ist:
              </p>
              <div className="space-y-1 mb-4">
                <p><strong>Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)</strong></p>
                <p>Kavalleriestraße 2–4, 40213 Düsseldorf</p>
                <p>Telefon: 0211 38424-0</p>
                <p>
                  <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer" 
                     className="text-violet-400 hover:text-violet-300 underline transition-colors">
                    www.ldi.nrw.de
                  </a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Analyse-Tools und Tools von Drittanbietern</h2>
              <p className="leading-relaxed">
                Diese Website verwendet keine Analyse-Tools oder Tracking-Technologien von Drittanbietern zur Auswertung 
                des Besucherverhaltens.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;